import { Injectable, ElementRef } from "@angular/core";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { ToastService } from "../core/services/toast.service";
import { AdminService } from "../core/endpoints/admin.service";

@Injectable({
	providedIn: "root",
})
export class NotificationService {
	message: any = null;
	private audio: HTMLAudioElement;

	constructor(
		private afMessaging: AngularFireMessaging,
		protected toast: ToastService,
		private adminService: AdminService
	) {
		this.audio = new Audio(); // Crea un elemento de audio
		this.audio.src = "assets/notificacion.mp3";
	}

	/**
	 * Solicitar permisos de notificaciones
	 */
	public requestPermission(): void {
		this.afMessaging.requestToken.subscribe({
			next: (token) => {
				this.adminService.storeToken({ token: token }).subscribe({
					next: () => {
						this.listen();
					},
					error: (error) => {
						console.log(error);
					},
					complete: () => {},
				});
			},
			error: (error) => {
				console.log("Error al solicitar permiso:", error);
			},
		});
	}

	/**
	 * Escucha de notificaciones
	 */
	public listen() {
		const messaging = getMessaging();
		onMessage(messaging, (payload) => {
			console.log("Message received. ", payload);
			if (payload) {
				this.toast.show(
					payload.notification["title"],
					payload.notification["body"],
					"success"
				);
				this.playNotificationSound();
			}
			this.message = payload;
		});
	}

	private playNotificationSound() {
		this.audio.pause();
		this.audio.currentTime = 0;

		this.audio.play();
	}
}
